module.exports = __webpack_public_path__ + "img/单相混合式逆变器.6ebbbe78.png";